module.exports = __webpack_public_path__ + "img/four.7e609cac.png";